<template>
  <div class='technology-version-table-cell'>
    <v-chip-group :show-arrows='true'>
      <v-chip x-small
              label
              outlined
              v-for="(version, index) in versions"
              :key="`${version}-${index}`"
              text-color="black"
              class='chip'
      >
        {{version}}
      </v-chip>
    </v-chip-group>
  </div>
</template>

<script>
export default {
  name: 'TechnologyVersionTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  computed: {
    versions() {
      return Array.from(new Set(this.item[this.column.field])).filter(version => version !== 'N/A');
    },
  },
};
</script>

<style lang='scss'>
@import '~@/assets/styles/design-system';
.technology-version-table-cell {
  z-index: 5;
  .v-slide-group__wrapper {
    padding-left: rem(15);
    padding-right: rem(14);
    background-color: transparent !important;
  }
  .v-slide-item {
    &:hover {
      cursor: default;
      opacity: 0;
      background-color: var(--bg-primary) !important;
    }
    &:focus::after {
      opacity: 0;
      background-color: var(--bg-primary) !important;
    }
  }
  .theme--light.v-chip:focus::before {
    opacity: 0;
  }
  .v-chip {
    pointer-events: none;
    &:hover {
      cursor: default;
      background-color: var(--bg-primary) !important;
    }
  }
  .v-slide-item--active {
    background-color: var(--bg-primary) !important;
    &:focus::after {
      opacity: 0;
      background-color: var(--bg-primary) !important;
    }
  }
  .v-chip--active {
    background: var(--bg-primary) !important;
  }
  .v-slide-group {
    height: 100%;
    padding: rem(15) 0;
  }
  .v-slide-group__next, .v-slide-group__prev {
    min-width: 0;
  }
  .v-item-group {
    max-width: rem(200);
  }
}
</style>
<style lang='scss' scoped>
@import '~@/assets/styles/design-system';
.technology-version-table-cell {
  margin-left: 4%;
  .version {
    z-index: 3;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: rem(150);
    color: var(--text-primary);
    font-family: $font-family-regular;
    font-size: rem(14);
    letter-spacing: 0;
    line-height: rem(17);
    border-radius: $radius-md;
  }
  .empty {
    color: var(--text-secondary);
  }
}
</style>
